import { CatBadge, CatHeading } from 'components/blocks-components';
import { Image } from 'components/image';
import { capitalizeText } from '@cat-ecom/common/utils/stringUtils';
import { equipmentDetailsProps } from '../../types';
import styles from '../service-insight-card.module.scss';

export const EquipmentDetails = ({
  equipmentDetails,
  isNewInsight,
  isDesktop = true
}: equipmentDetailsProps) => {
  return (
    <div className="d-flex flex-row align-items-center">
      {isNewInsight && isDesktop && (
        <CatBadge
          isDot
          className={'cat-u-margin-right-md'}
          data-testid="cat-badge"
        />
      )}

      <Image
        src={equipmentDetails.imageURL}
        alt={equipmentDetails.imageURL}
        className={styles['equipmentInfo_img']}
        width={60}
        height={44}
        loading="lazy"
      />
      <div className="d-flex flex-column cat-u-margin-left-sm">
        <CatHeading
          variant="footnote-bold"
          className={`${styles['equipmentInfo_truncate']} ${styles['equipmentInfo_nickName']}`}
        >
          {capitalizeText(equipmentDetails?.assetName ?? '')}
        </CatHeading>
        <CatHeading
          variant={equipmentDetails?.assetName ? 'footnote' : 'footnote-bold'}
          className={`${styles['equipmentInfo_truncate']} ${styles['equipmentInfo_model']}`}
        >
          {`${equipmentDetails.model} ${capitalizeText(equipmentDetails?.name ?? equipmentDetails?.productFamily)}`}
        </CatHeading>
        <CatHeading
          variant="footnote"
          className={styles['equipmentInfo_serial']}
        >
          {equipmentDetails.serialNumber}
        </CatHeading>
      </div>
    </div>
  );
};
